import useThemeRender from "../../theme/useThemeRender";
import InternalCarousal from "../InternalPages/Carousal-ExpandedView/InternalCarousal";
import "./FritoForumDetailPage.css";
import { Box } from "@mui/material";
const ForumAssociatedContent = ({
  linksData,
  videoData,
  documentData,
  cardButtonDisable,
}) => {
  const backgroundColorLayer3 = useThemeRender("backgroundColorLayer3");
  const textColorLayer2 = useThemeRender("textColorLayer2");
  return (
    <>
      <Box
        sx={{
          color: textColorLayer2,
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
          fontSize: "var(--Font-Size-H5, 24px)",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "var(--Line-Height-H5, 32px)",
          marginLeft: "15px",
          mb: "10px",
        }}
      >
        Associated Content
      </Box>
      {/* {documentData?.length > 0 && ( */}
      <Box
        sx={{
          backgroundColor: backgroundColorLayer3,
        }}
        className="curosalBackground"
      >
        <InternalCarousal
          data={documentData}
          content={"Documents"}
          flexDirection={"column"}
          heading={"Documents"}
          isHeadingBig={false}
          cardButtonDisable={cardButtonDisable}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: backgroundColorLayer3,
        }}
        className="curosalBackground"
      >
        <InternalCarousal
          data={videoData}
          content={"Videos"}
          flexDirection={"column"}
          heading={"Videos"}
          isHeadingBig={false}
          cardButtonDisable={cardButtonDisable}
        />
      </Box>

      <Box
        sx={{
          backgroundColor: backgroundColorLayer3,
          marginBottom: "16px",
        }}
        className="curosalBackground"
      >
        <InternalCarousal
          data={linksData}
          content={"Links"}
          flexDirection={"column"}
          heading={"Links"}
          isHeadingBig={false}
          cardButtonDisable={cardButtonDisable}
        />
      </Box>
    </>
  );
};

export default ForumAssociatedContent;
